exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer .popupModalContainer {\n  position: relative;\n}\nfooter .popupModal {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\nfooter #fullsize-modal .modal-content {\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/less-loader!../node_modules/xo-page-components/src/footer/styles.less
// module id = ../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!../node_modules/xo-page-components/src/footer/styles.less
// module chunks = 0